/* Layout */
import Layout from '@/layout/index.vue'

export default [
  {
    path: '/accounts',
    redirect: '/ledger',
    component: Layout,
    meta: {
      authRequired: true,
      permission: 'op@bill',
      icon: 'bi bi-journals',
      title: 'Ledgers'
    },
    children: [
      {
        path: '/ledger',
        name: 'Ledger',
        component: () => import(/* webpackChunkName: "accounts" */ '../components/Ledger.vue'),
        meta: {
          authRequired: true,
          permission: 'op@bill',
          icon: 'bi bi-journals',
          title: 'Ledger'
        }
      }
    ]
  }
]
